// extracted by mini-css-extract-plugin
export default {"sharedBox":"style-module--sharedBox--IHF1F"};